export class ListItem {
    constructor(id: number, text: string, completed: boolean, components: boolean, type?: ListItemType, typedData?: any) {
        this.id = id;
        this.text = text;
        this.completed = completed;
        this.components = components;
        this.type = type;
        this.typedData = typedData;
    }
    id: number;
    text: string;
    completed: boolean;
    components: boolean;
    required?: boolean;
    type?: ListItemType;
    typedData?: any;
}

export enum ListItemType {
    Default = 0,
    Comment = 1,
    Header = 2,
    RadioGroup = 3,
    ScanCell = 20,
    Signature = 40,
}

export type CellForVSelect = {
    id: number, 
    name: string,
};